import {
  initialState,
  Actions,
  State,
  NEW_CUSTOM_CONTENT_TYPE,
  NEW_CUSTOM_CONTENT_TYPE_SUCCESS,
  NEW_CUSTOM_CONTENT_TYPE_ERROR,
  RESET_NEW_CUSTOM_CONTENT_TYPE,
} from '../../types/custom-content-tye/new'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_CUSTOM_CONTENT_TYPE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case NEW_CUSTOM_CONTENT_TYPE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case NEW_CUSTOM_CONTENT_TYPE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_NEW_CUSTOM_CONTENT_TYPE:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
